<script>
    import { onMount } from "svelte";
    import Cinema from "../components/Cinema.svelte";
    import ajaxFetch from "../services/ajaxFetch";
    import {
        getAllSellerFilters,
        getSearchFilter,
        hasSellerFilters,
        removeAllSellerFilter,
        removeSellerFilter,
    } from "../services/searchFilterHandler.js";

    /**
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        variationId,
        featureIndex,
        performance,
        eventMergeId = null,
        cinemaInjectionContainerWidth = 1000,
        recommendationsEndpoint = "/reco-core/recommendations/alternative/variations/",
    } = $props();

    let cinemaFilters = $state([]);
    let cinemaHasLoaded = $state(false);
    let headline = $state(),
        recommendations = $state(),
        tracking = $state(),
        additionalClickTracking = $state(),
        metaData = $state(),
        featuresState = $state(),
        filters;
    let noRecommendationsFoundWithSellerFilters = $state(false);
    let refreshing = $state("");
    let hasPersonalisedRecommendations = $state();

    const removeFilter = (seller) => {
        const searchFilter = removeSellerFilter(seller.value);
        refreshing = "__loading";
        loadAlternatives(searchFilter);
    };

    const getCinemaFilters = (filters) => {
        if (!filters || filters.length === 0) {
            return [];
        }
        const sellers = getAllSellerFilters();
        if (sellers.length !== 1) {
            return [];
        }
        return filters.filter((filter) => sellers.some((seller) => filter.value === seller));
    };

    const loadAlternatives = async (searchFilter) => {
        const requestHeader = searchFilter ? { headers: { filters: searchFilter } } : {};

        const res = await ajaxFetch(`${recommendationsEndpoint}${variationId}`, requestHeader);

        if (res.status !== 200) {
            return;
        }
        ({
            headline,
            recommendations,
            tracking,
            additionalClickTracking,
            metaData,
            filters,
            featuresState,
            hasPersonalisedRecommendations = false,
        } = await res.json());

        cinemaFilters = getCinemaFilters(filters);
        if (recommendations == null || recommendations.length === 0) {
            if (featuresState.ENABLE_VENDOR_CHIPS_FILTER && hasSellerFilters()) {
                noRecommendationsFoundWithSellerFilters = true;
                removeAllSellerFilter();
                await loadAlternatives();
                return;
            } else {
                noRecommendationsFoundWithSellerFilters = false;
                return;
            }
        }
        cinemaHasLoaded = true;
        if (featuresState.ENABLE_VENDOR_CHIPS_FILTER) {
            refreshing = "";
        }
    };

    onMount(async () => {
        performance.cinemaLoadingStarted();
        const searchFilter = getSearchFilter(document.referrer);
        await loadAlternatives(searchFilter);
    });
</script>

{#if cinemaHasLoaded}
    <div class="reco_alternative_cinema_wrapper{refreshing}">
        {#key refreshing}
            <Cinema
                {headline}
                {recommendations}
                {tracking}
                {featureIndex}
                {additionalClickTracking}
                {featuresState}
                {cinemaInjectionContainerWidth}
                cinemaMeta={metaData}
                trackingEventMergeId={eventMergeId}
                loadedTrackingActionName="change"
                {performance}
                site="RecoDetailViewAlternative"
                showTopInfo={true}
                {cinemaFilters}
                removeFilterCallBack={removeFilter}
                {noRecommendationsFoundWithSellerFilters}
                personalisedUser={hasPersonalisedRecommendations}
            />
        {/key}
    </div>
{/if}

<style lang="scss">
    .reco_alternative_cinema_wrapper {
        min-height: 360px;
        max-height: 672px;
        position: relative;

        &__loading {
            pointer-events: none;
            opacity: 0.5;
        }
    }
</style>
